<template>
  <homepage>
    <div class="m-block">
      <div class="row">
        <div class="col-sm-6 col-xs-12">
          <p><strong>{{ $t('contact.contact_us') }}</strong></p>
          <strong>{{ $t('contact.our_email') }}:</strong> ntg@ufv.br<br>
          <strong>{{ $t('contact.our_phones') }}:</strong> (31) 3899 4097 ou (31) 3899 4086<br>
          <strong>{{ $t('contact.our_address') }}:</strong><br>
          Universidade Federal de Viçosa (UFV)<br>
          Departamento de Engenharia de Produção e Mecânica (DEP)<br>
          Avenida Prof. Peter Henry Rolfs, s/n – Campus Universitário<br>
          CEP: 36570-900 – Viçosa – MG
          <br /><br />
          <div v-if="formStatus === FORM_STATUS_SUBMIT_SUCCESS" class="alert alert-success text-center" role="alert">
            {{ $t('contact.form.alerts.success') }}
          </div>
          <div v-if="formStatus === FORM_STATUS_SUBMIT_ERROR" class="alert alert-danger text-center" role="alert">
            {{ $t('contact.form.alerts.error') }}
          </div>
          <form>
            <div :class="[{'has-error': formData.name.error }, 'form-group']">
              <label class="control-label" for="name">{{ $t('contact.form.name') }}</label>
              <input 
                v-model="formData.name.value" 
                @change="validateRequiredField('name')" 
                type="text" 
                class="form-control" 
                id="name" 
                aria-describedby="helpBlockName">
              <span id="helpBlockName" class="help-block" v-if="formData.name.error">
                {{ $t(`contact.form.validation.${formData.name.error}`) }}
              </span>
            </div>
            <div :class="[{'has-error': formData.email.error }, 'form-group']">
              <label for="email">{{ $t('contact.form.email') }}</label>
              <input 
                v-model="formData.email.value"
                @change="validateEmailField('email')" 
                type="email" 
                class="form-control" 
                id="email" 
                aria-describedby="helpBlockEmail">
              <span id="helpBlockEmail" class="help-block" v-if="formData.email.error">
                {{ $t(`contact.form.validation.${formData.email.error}`) }}
              </span>
            </div>
            <div :class="[{'has-error': formData.subject.error }, 'form-group']">
              <label for="subject">{{ $t('contact.form.subject') }}</label>
              <input 
                v-model="formData.subject.value" 
                @change="validateRequiredField('subject')" 
                type="text" 
                class="form-control" 
                id="subject" 
                aria-describedby="helpBlockSubject">
              <span id="helpBlockSubject" class="help-block" v-if="formData.subject.error">
                {{ $t(`contact.form.validation.${formData.subject.error}`) }}
              </span>
            </div>
            <div :class="[{'has-error': formData.message.error }, 'form-group']">
              <label for="message">{{ $t('contact.form.message') }}</label>
              <textarea 
                v-model="formData.message.value" 
                @change="validateRequiredField('message')" 
                id="message" 
                class="form-control" 
                rows="3" 
                aria-describedby="helpBlockMessage">
              </textarea>
              <span id="helpBlockMessage" class="help-block" v-if="formData.message.error">
                {{ $t(`contact.form.validation.${formData.message.error}`) }}
              </span>
            </div>
            <vue-recaptcha 
              ref="recaptcha"
              :sitekey="recaptcha_site_key"
              @verify="onCaptchaVerified"
              @expired="onCaptchaExpired">
              <button type="submit" class="btn btn-default" :disabled="formStatus === FORM_STATUS_SUBMITTING">{{ $t('contact.form.submit') }}</button>
            </vue-recaptcha>
          </form>
        </div>
        <div class="col-sm-6 col-xs-12">
          <gmap-map :center="{lat: -20.760829, lng: -42.866235}" :zoom="14" class="map">
            <gmap-marker
            :position='{lat: -20.760829, lng: -42.865235}'
            :clickable='false'
            :draggable='false'>
            </gmap-marker>
          </gmap-map>
        </div>
      </div>
    </div>
  </homepage>
</template>

<script>
import ContactClient from '@/services/resource_client/contact'
import Homepage from '@/pages/portal/Homepage'
import VueRecaptcha from 'vue-recaptcha'

const FORM_STATUS_SUBMITTING = 'submitting'
const FORM_STATUS_SUBMIT_SUCCESS = 'submit_success'
const FORM_STATUS_SUBMIT_ERROR = 'submit_error'

export default {
  name: 'ContactPage',
  components: { Homepage, VueRecaptcha },
  data () {
    return {
      recaptcha_site_key: process.env.RECAPTCHA_SITE_KEY,

      formData: {
        name: {
          value: '',
          error: ''
        },
        email: {
          value: '',
          error: ''
        },
        subject: {
          value: '',
          error: ''
        },
        message: {
          value: '',
          error: ''
        }
      },

      formStatus: '',
      FORM_STATUS_SUBMITTING,
      FORM_STATUS_SUBMIT_SUCCESS,
      FORM_STATUS_SUBMIT_ERROR
    }
  },
  methods: {
    onCaptchaVerified (recaptchaToken) {
      if (!this.validateForm() || this.formStatus === FORM_STATUS_SUBMITTING) { return }
      this.formStatus = FORM_STATUS_SUBMITTING

      const self = this
      ContactClient.post(
          this.formData.name.value,
          this.formData.email.value,
          this.formData.subject.value,
          this.formData.message.value,
          recaptchaToken
        ).then(() => {
          self.clearFormValuesAndErrors()
          this.formSubmissionSuccess = true
          this.formStatus = FORM_STATUS_SUBMIT_SUCCESS
        }).catch(() => {
          this.formSubmissionError = true
          this.formStatus = FORM_STATUS_SUBMIT_ERROR
        })
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },
    validateRequiredField (fieldName) {
      this.formData[fieldName].error = ''

      if (!this.formData[fieldName].value) {
        this.formData[fieldName].error = 'requiredField'
        return false
      }
      return true
    },
    validateEmailField (fieldName) {
      this.formData[fieldName].error = ''

      const emailValue = this.formData[fieldName].value
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!re.test(String(emailValue).toLowerCase())) {
        this.formData[fieldName].error = 'invalidEmailAddress'
        return false
      }
      return true
    },
    validateForm () {
      let isValid = true
      Object.keys(this.formData).forEach((fieldKey) => {
        if (!this.validateRequiredField(fieldKey)) {
          isValid = false
        }
      })

      if (!this.validateEmailField('email')) {
        isValid = false
      }

      return isValid
    },
    clearFormValuesAndErrors () {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key].value = ''
        this.formData[key].error = ''
      })
    }
  }
}
</script>

<style scoped>
  .map {
    width: 100%; 
    height: 575px;
    margin-top: 3rem;
  }

  @media (min-width: 768px) { 
   .map {
    margin-top: 0;  
   } 
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?73b7b026